import React, { FC } from 'react';

interface LocationExternalLinkIconProps {
	className?: string;
	size?: number;
}

/**
 * "Open in new" affordance shown beside a location name (side list + map tooltip). Uses
 * `currentColor` so the wrapping element's text colour (e.g. `text-buyer` / `text-supplier`) tints
 * it. The path mirrors `EXTERNAL_LINK_ICON_SVG` in LocationsMapPopupUtils — keep the two in sync.
 */
export const LocationExternalLinkIcon: FC<LocationExternalLinkIconProps> = ({
	className,
	size = 14,
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		aria-hidden="true"
		focusable="false"
	>
		<path
			d="M1.07122 0.64447H10.9284C11.1654 0.64447 11.3569 0.835988 11.3569 1.07304V10.9302C11.3569 11.1672 11.1654 11.3588 10.9284 11.3588H6.10693C6.048 11.3588 5.99979 11.3105 5.99979 11.2516V10.5016C5.99979 10.4427 6.048 10.3945 6.10693 10.3945H10.3926V1.60876H1.60693V5.89447C1.60693 5.9534 1.55872 6.00161 1.49979 6.00161H0.74979C0.690862 6.00161 0.642647 5.9534 0.642647 5.89447V1.07304C0.642647 0.835988 0.834165 0.64447 1.07122 0.64447ZM4.10738 7.17215L3.40827 6.47304C3.39411 6.45881 3.38423 6.44089 3.37975 6.42132C3.37526 6.40175 3.37636 6.38131 3.38292 6.36233C3.38948 6.34336 3.40123 6.3266 3.41684 6.31397C3.43245 6.30135 3.45129 6.29335 3.47122 6.2909L5.8739 6.00965C5.9422 6.00161 6.00113 6.0592 5.99309 6.12885L5.71184 8.53152C5.70113 8.61992 5.59265 8.65742 5.5297 8.59447L4.82792 7.89269L1.39666 11.3239C1.35515 11.3655 1.28684 11.3655 1.24533 11.3239L0.677468 10.7561C0.63595 10.7146 0.63595 10.6463 0.677468 10.6047L4.10738 7.17215Z"
			fill="currentColor"
		/>
	</svg>
);
